import Vue from 'vue'
import VueRouter from 'vue-router'
import Apps from '../views/Apps'

Vue.use(VueRouter)

const routes = [
  {
    path: '/bp',
    name: 'bp',
    component: () => import('../views/auth/_BP')
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../views/auth/Login')
  },
  {
    path: '/Register',
    name: 'Register',
    component: () => import('../views/auth/Register')
  },
  {
    path: '/Notify',
    name: 'Notify',
    component: () => import('../views/Notify')
  },
  {
  path: '/',
  name: 'Apps',
  component: Apps,
  redirect: '/Dashboard',
  meta: { auth: true },
    children: [
      {
        path: '/OT',
        name: 'OT',
        component: () => import('../views/OT')
      },
      {
        path: '/Dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard')
      },
      {
        path: '/Repairs',
        name: 'Repairs',
        component: () => import('../views/Repairs')
      },
      {
        path: '/Repairs/:id',
        name: 'RepairStatus',
        component: () => import('../views/RepairStatus')
      },
      {
        path: '/Users',
        name: 'Users',
        component: () => import('../views/Users')
      },
      {
        path: '/Roles',
        name: 'Roles',
        component: () => import('../views/Roles')
      },
      {
        path: '/Departments',
        name: 'Departments',
        component: () => import('../views/Departments')
      },
      {
        path: '/Profile',
        name: 'Profile',
        component: () => import('../views/Profile')
      },
      {
        path: '/Report',
        name: 'Report',
        component: () => import('../views/Report')
      },
      {
        path: '/ReportMonthly',
        name: 'ReportMonthly',
component: () => import('../views/ReportMonthly')
      },
      {
        path: '/ReportOT',
        name: 'ReportOT',
        component: () => import('../views/ReportOT')
      },
      {
        path: '/RegisterHosxp',
        name: 'RegisterHosxp',
        component: () => import('../views/RegisterHosxp')
      },
      {
        path: '/Event',
        name: 'Event',
        component: () => import('../views/Event')
      },
      {
        path: '/Print',
        name: 'Print',
        component: () => import('../views/Print')
      },
    ]
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active",
})

router.beforeEach((to, from, next) => {

  const token = localStorage.getItem("token")

  const requiresAuth = to.matched.some(record => record.meta.auth)

  if (requiresAuth && !token) {

    next("/Login")

  } 
  else if (to.path === "/Login" && token) {

    next("/Dashboard")

  } 
  else {

    next()

  }

})

export default router
